import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import IndexPage from '../../components/IndexPage/IndexPage/IndexPage_C';
function mapDispatchToProps(_ref) {
  var indexPage = _ref.indexPage;
  return {
    indexPage: indexPage
  };
}
var IndexPageR = _Form.create()(IndexPage);
export default connect(mapDispatchToProps)(IndexPageR);